export const INVITED = "INVITED";
export const SIGNED_UP = "SIGNED UP";
export const SUBSCRIBED = "SUBSCRIBED";
export const PENDING = "PENDING";
export const SENT = "SENT";
